import { appState } from './state.app'

const initialVideoState = {
    volume: 0.5,
    mute: false,
}

const setVideoState = appState('VIDEO', initialVideoState)

export const getVideoState = () => appState().VIDEO

export const setVideoVolumeState = (volume: number) => {
    setVideoState({ modifications: { volume } })
}

export const setVideoMuteState = (mute: boolean) => {
    setVideoState({ modifications: { mute } })
}
